// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  production: false,
  salesforce_url: "https://sogelink--roald.sandbox.lightning.force.com",
  // Replaces webkuaapiv3-dev -- that was the never-finished half of an earlier
  // cleanup effort (the sg-no-* naming convention was already in place, but the
  // cutover was abandoned). Confirmed 2026-09-17 this is the intended dev API
  // going forward, not a stray duplicate.
  backend_url: "https://sg-no-webkua-api-dev-ahatbwfrh4hsdabt.westeurope-01.azurewebsites.net/api",
  //backend_url: "https://sg-no-webkua-api-uat-hgbmenbwardff9ex.westeurope-01.azurewebsites.net/api",
  course_backend_url: "https://focuscourseapi-dev.azurewebsites.net/api"
};
